import { dashboard } from "@/utils/constants";
import { handleError, handleResponse } from "@/utils/functions";

export default (axios) => ({
  getAdminDashboardData(params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(dashboard.adminDashboardBase, {
          params: params,
        })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getTransporterDashboardData(params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(dashboard.transporterDashboardBase, {
          params: params,
        })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getCustomerDashboardData(params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(dashboard.customerDashboardBase, {
          params: params,
        })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
 getLiveManagementDashboardData(params = {}) {
  return new Promise((resolve, reject) => {
    axios
      .get(dashboard.adminManagementDashboardBase, {
        params: params,
      })
      .then((res) => {
        resolve(handleResponse(res));
      })
      .catch((err) => {
        reject(handleError(err));
      });
  });
},

getLiveManagementExternalDashboardData(params = {}) {
  return new Promise((resolve, reject) => {
    axios
      .get(dashboard.adminManagementExternalDashboard, {
        params: params,
      })
      .then((res) => {
        resolve(handleResponse(res));
      })
      .catch((err) => {
        reject(handleError(err));
      });
  });
},

getLiveManagementInternalDashboardData(params = {}) {
  return new Promise((resolve, reject) => {
    axios
      .get(dashboard.adminManagementInternalDashboard, {
        params: params,
      })
      .then((res) => {
        resolve(handleResponse(res));
      })
      .catch((err) => {
        reject(handleError(err));
      });
  });
},

getManagementDashboardSummary(params = {}) {
  return new Promise((resolve, reject) => {
    axios
      .get(dashboard.managementDashboardSummary, { params })
      .then((res) => resolve(handleResponse(res)))
      .catch((err) => reject(handleError(err)));
  });
},

getManagementDashboardDailyExitFleet(params = {}) {
  return new Promise((resolve, reject) => {
    axios
      .get(dashboard.managementDashboardDailyExitFleet, { params })
      .then((res) => resolve(handleResponse(res)))
      .catch((err) => reject(handleError(err)));
  });
},

getManagementDashboardTransporterAnalytics(params = {}) {
  return new Promise((resolve, reject) => {
    axios
      .get(dashboard.managementDashboardTransporterAnalytics, { params })
      .then((res) => resolve(handleResponse(res)))
      .catch((err) => reject(handleError(err)));
  });
},

getManagementDashboardLocationDeepDive(params = {}) {
  return new Promise((resolve, reject) => {
    axios
      .get(dashboard.managementDashboardLocationDeepDive, { params })
      .then((res) => resolve(handleResponse(res)))
      .catch((err) => reject(handleError(err)));
  });
},

getManagementDashboardContainerTypeMix(params = {}) {
  return new Promise((resolve, reject) => {
    axios
      .get(dashboard.managementDashboardContainerTypeMix, { params })
      .then((res) => resolve(handleResponse(res)))
      .catch((err) => reject(handleError(err)));
  });
},

getManagementDashboardCostRevenue(params = {}) {
  return new Promise((resolve, reject) => {
    axios
      .get(dashboard.managementDashboardCostRevenue, { params })
      .then((res) => resolve(handleResponse(res)))
      .catch((err) => reject(handleError(err)));
  });
},

getManagementLiveTripData(params = {}) {
  return new Promise((resolve, reject) => {
    axios
      .get(dashboard.managementLiveTrip, { params })
      .then((res) => resolve(handleResponse(res)))
      .catch((err) => reject(handleError(err)));
  });
},
});
